import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IStudyReportTemplate } from './_types';

export const getStudyReportTemplate = (id: number): Promise<IStudyReportTemplate> =>
  api()
    .get(`/portal-api/template/get`, { params: { id } })
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const getStudyReportTemplates = (): Promise<IStudyReportTemplate[]> =>
  api()
    .get(`/portal-api/template/getAll`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const editStudyReportTemplate = (data: IStudyReportTemplate): Promise<boolean> =>
  api()
    .put(`/portal-api/template/update`, data)
    .then((response) => true)
    .catch((error) => false);

export const createStudyReportTemplate = (data: IStudyReportTemplate): Promise<boolean> =>
  api()
    .post(`/portal-api/template/create`, data)
    .then((response) => true)
    .catch((error) => false);

export const removeStudyReportTemplate = (id: number): Promise<boolean> =>
  api()
    .delete(`/portal-api/template/delete`, { params: { id } })
    .then((response) => true)
    .catch((error) => false);

export const importStudyReportTemplates = (): Promise<IStudyReportTemplate[]> =>
  api()
    .post(`/portal-api/template/importTemplates`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
